<div class="relative h-[150px] mb-4 bg-[#7B68EE]">
  <div class="flex flex-col gap-4 justify-center items-center w-full h-full px-3 md:px-0">
    <img src="assets/images/logo.png" class="w-full h-20 object-contain" />
  </div>
</div>

<div class="mr-4 m-2 mt-12 text-2xl font-bold border-b-2 border-purple-600">
  <h1 class="mb-1">
    All Categories from <b class="text-blue-600">{{sellerStoreDetails?.storeName}}</b>
  </h1>
</div>

<div class="flex flex-wrap justify-start">
  <span
    class="flex flex-col items-center m-2 cursor-pointer"
    *ngFor="let cate of categories"
    (click)="filterProductsByCategory(cate)"
  >
  <img
  [src]="cate?.imageUrl ? vendorCateemageUrl + cate.imageUrl : 'https://previews.123rf.com/images/ionutparvu/ionutparvu1612/ionutparvu161200410/67602131-categories-stamp-sign-text-word-logo-red.jpg'"
  class="w-24 h-24 border-2 border-[#C963F8] rounded-full bg-white object-cover m-1"
/>
    <b class="ml-1 text-center">{{ cate?.name }}</b>
  </span>
</div>

<div class="m-2 mr-4 text-2xl font-bold overflow-hidden">
  <h1 class="border-b-2 border-purple-600">
    Collection from <b class="text-blue-600">{{sellerStoreDetails?.storeName}}</b>
  </h1>
  <div class="flex flex-wrap justify-center m-5 p-2 gap-4">
    <div
      class="addcolor shadow-md shadow-black rounded-lg w-56 card cursor-pointer"
      [class.bg-black]="selectedCategory === 'all'"
      [class.text-white]="selectedCategory === 'all'"
      (click)="changeCategory('all')"
    >
      <img
        src="assets/quality.png"
        class="p-2 w-20 h-20 mx-auto"
        [ngStyle]="
          selectedCategory === 'all'
            ? {}
            : {
                'mix-blend-mode': 'multiply',
                filter: 'brightness(0) saturate(100%)'
              }
        "
      />
      <h1 class="text-center p-2">All Products</h1>
    </div>

    <div
      class="addcolor shadow-md shadow-black rounded-lg w-56 card cursor-pointer"
      [class.bg-black]="selectedCategory === 'newlyArrived'"
      [class.text-white]="selectedCategory === 'newlyArrived'"
      (click)="changeCategory('newlyArrived')"
    >
      <img
        [ngStyle]="
          selectedCategory === 'newlyArrived'
            ? {}
            : {
                'mix-blend-mode': 'multiply',
                filter: 'brightness(0) saturate(100%)'
              }
        "
        src="assets/new.png"
        class="p-2 w-20 h-20 mx-auto"
      />
      <h1 class="text-center p-2">Newly Arrives</h1>
    </div>

    <div
      class="addcolor shadow-md shadow-black rounded-lg w-56 card cursor-pointer"
      [class.bg-black]="selectedCategory === 'bestOffer'"
      [class.text-white]="selectedCategory === 'bestOffer'"
      (click)="changeCategory('bestOffer')"
    >
      <img
        [ngStyle]="
          selectedCategory === 'bestOffer'
            ? {}
            : {
                'mix-blend-mode': 'multiply',
                filter: 'brightness(0) saturate(100%)'
              }
        "
        src="assets/offers.png"
        class="p-2 w-20 h-20 mx-auto"
      />
      <h1 class="text-center p-2">Best Offers</h1>
    </div>

    <div
      class="addcolor shadow-md shadow-black rounded-lg w-56 card cursor-pointer"
      [class.bg-black]="selectedCategory === 'topQuality'"
      [class.text-white]="selectedCategory === 'topQuality'"
      (click)="changeCategory('topQuality')"
    >
      <img
        [ngStyle]="
          selectedCategory === 'topQuality'
            ? {}
            : {
                'mix-blend-mode': 'multiply',
                filter: 'brightness(0) saturate(100%)'
              }
        "
        src="assets/quality.png"
        class="p-2 w-20 h-20 mx-auto"
      />
      <h1 class="text-center p-2">Top Quality</h1>
    </div>

    <div
      class="addcolor shadow-md shadow-black rounded-lg w-56 card cursor-pointer"
      [class.bg-black]="selectedCategory === 'popular'"
      [class.text-white]="selectedCategory === 'popular'"
      (click)="changeCategory('popular')"
    >
      <img
        [ngStyle]="
          selectedCategory === 'popular'
            ? {}
            : {
                'mix-blend-mode': 'multiply',
                filter: 'brightness(0) saturate(100%)'
              }
        "
        src="assets/offers.png"
        class="p-2 w-20 h-20 mx-auto"
      />
      <h1 class="text-center p-2">Popular Products</h1>
    </div>
  </div>
</div>

<div class="flex flex-wrap items-center m-2 mt-5"  #productsSection>
  <h1 class="m-3 text-2xl font-bold">
    {{ selectedCategory | titlecase }} Products
  </h1>
</div>

<!-- Products Section -->
<div class="card border-2 border-purple-700 m-4 p-4 rounded-lg" >
  <div *ngIf="products.length > 0; else noProducts" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
    <app-product
      *ngFor="let product of products"
      [product]="product"
    ></app-product>
  </div>
  <ng-template #noProducts>
    <div class="text-center text-gray-500 py-8">
      <p>No products found for this category.</p>
    </div>
  </ng-template>
</div>